/**
 * Opens a checkout for ONE pack variant without touching the meal cart.
 * Used by the Packs page (sections/package.liquid) for every pack, the
 * student pack included. See docs/packs-checkout.md.
 *
 *  1. Storefront API cart (token configured): a brand-new cart → its
 *     checkoutUrl. The online-store cart is never touched.
 *  2. Fallback: an empty meal cart just gets the pack and goes to /checkout;
 *     a non-empty one is parked in localStorage (assets/order-now.js
 *     restoreParkedCart puts it back) and the pack goes through a permalink.
 *
 * BBXPackCheckout.open(variantId, { token, apiVersion, email, country }) → Promise<url>
 * BBXPackCheckout.go(url) navigates (tests intercept via window.__bbxNavigate).
 */
(function () {
  function storefront(variantId, o) {
    var input = { lines: [{ merchandiseId: 'gid://shopify/ProductVariant/' + variantId, quantity: 1 }], attributes: [{ key: '_bbx_pack', value: 'true' }] };
    if (o.email) input.buyerIdentity = { email: o.email, countryCode: o.country || 'CA' };
    return fetch('/api/' + (o.apiVersion || '2026-04') + '/graphql.json', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': o.token },
      body: JSON.stringify({ query: 'mutation($input: CartInput!) { cartCreate(input: $input) { cart { checkoutUrl } userErrors { message } } }', variables: { input: input } }),
    }).then(function (r) { return r.json(); }).then(function (res) {
      var data = res && res.data && res.data.cartCreate;
      var url = data && data.cart && data.cart.checkoutUrl;
      if (!url) throw new Error((data && data.userErrors && data.userErrors.map(function (e) { return e.message; }).join('; ')) || (res.errors && res.errors[0] && res.errors[0].message) || 'no checkoutUrl');
      return url;
    });
  }
  function fallback(variantId) {
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      if (!c.items || !c.items.length) {
        return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: Number(variantId), quantity: 1 }) })
          .then(function (r) { if (!r.ok) throw new Error('add failed ' + r.status); return '/checkout'; });
      }
      try {
        localStorage.setItem('bbx_parked_cart', JSON.stringify({ ts: Date.now(), items: c.items.map(function (i) { return { id: i.variant_id, quantity: i.quantity, properties: i.properties || {} }; }), attributes: c.attributes || {}, note: c.note || '' }));
      } catch (e) { /* storage unavailable: still proceed */ }
      return '/cart/' + variantId + ':1';
    });
  }
  window.BBXPackCheckout = {
    open: function (variantId, o) {
      o = o || {};
      return o.token
        ? storefront(variantId, o).catch(function (err) { console.warn('[packs] storefront checkout failed, falling back', err); return fallback(variantId); })
        : fallback(variantId);
    },
    go: function (url) { if (window.__bbxNavigate) window.__bbxNavigate(url); else window.location.href = url; },
  };
})();
